import { useEffect, useState } from "react";

/**
 * Tick a cada 30s enquanto houver ETA de auto-resume na tela (LAC-138/194).
 * Um único intervalo na lista cobre várias linhas pausadas.
 */
export function useCircuitAutoResumeNowMs(active: boolean): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!active) {
      return;
    }
    setNowMs(Date.now());
    const timerId = window.setInterval(() => setNowMs(Date.now()), 30000);
    return () => window.clearInterval(timerId);
  }, [active]);

  return nowMs;
}
